"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _panel = _interopRequireDefault(require("../panel"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _SSIFooter = _interopRequireDefault(require("./SSIFooter"));

var _CustomFooter = _interopRequireDefault(require("./CustomFooter"));

var _api = require("../../utils/api");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var options = [(0, _preact.h)("div", {
  key: "default"
}, (0, _preact.h)("strong", null, "Default"), (0, _preact.h)("div", null, "Use default footer")), (0, _preact.h)("div", {
  key: "ssi"
}, (0, _preact.h)("strong", null, "Server Side Include (SSI) configuration"), (0, _preact.h)("div", null, "Include external HTML footer via URL")), (0, _preact.h)("div", {
  key: "custom"
}, (0, _preact.h)("strong", null, "Custom code only"), (0, _preact.h)("div", null, "Add footer via custom HTML"))];

var CommunityHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CommunityHeader, _Component);

  var _super = _createSuper(CommunityHeader);

  function CommunityHeader() {
    var _this;

    (0, _classCallCheck2.default)(this, CommunityHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedOption: 0,
      ssiFooter: {
        url: ''
      },
      customFooter: {
        html: ''
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CommunityHeader, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return (0, _api.getCommunityFooterConfig)();

              case 3:
                _context.t1 = _context.sent;

                _context.t0.setStateFromBackend.call(_context.t0, _context.t1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setStateFromBackend",
    value: function setStateFromBackend(data) {
      this.setState({
        selectedOption: ['default', 'ssi', 'custom'].indexOf(data.type),
        ssiFooter: data.ssiFooter,
        customFooter: data.customFooter
      });
    }
  }, {
    key: "save",
    value: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var type, updated;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  error: false,
                  success: false,
                  isLoading: true
                });
                type = 'default';
                if (this.state.selectedOption === 1) type = 'ssi';
                if (this.state.selectedOption === 2) type = 'custom';
                _context2.prev = 4;
                _context2.next = 7;
                return (0, _api.updateCommunityFooterConfig)({
                  type: type,
                  ssiFooter: this.state.ssiFooter,
                  customFooter: this.state.customFooter
                });

              case 7:
                updated = _context2.sent;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                this.setState({
                  error: true,
                  isLoading: false
                });
                return _context2.abrupt("return");

              case 14:
                this.setStateFromBackend(updated);
                this.setState({
                  success: true,
                  isLoading: false
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selectedOption = _this$state.selectedOption,
          ssiFooter = _this$state.ssiFooter,
          customFooter = _this$state.customFooter,
          success = _this$state.success,
          error = _this$state.error,
          isLoading = _this$state.isLoading;
      var subComponents = [null, (0, _preact.h)(_SSIFooter.default, (0, _extends2.default)({
        key: "ssi-footer"
      }, ssiFooter, {
        onChange: function onChange(newData) {
          _this2.setState(function (state) {
            return {
              ssiFooter: _objectSpread(_objectSpread({}, state.ssiFooter), newData)
            };
          });
        }
      })), (0, _preact.h)(_CustomFooter.default, (0, _extends2.default)({
        key: "custom-footer"
      }, customFooter, {
        onChange: function onChange(newData) {
          _this2.setState(function (state) {
            return {
              customFooter: _objectSpread(_objectSpread({}, state.customFooter), newData)
            };
          });
        }
      }))];
      return (0, _preact.h)("div", {
        className: "community-footer"
      }, (0, _preact.h)(_header.default, {
        title: "Footer",
        saveCallback: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this2.save();

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })),
        isLoading: isLoading
      }), error && (0, _preact.h)(_AlertComponent.default, {
        messageType: "error",
        message: "Could not save configuration",
        renderHTML: true,
        isVisibleFor: 3000
      }), success && (0, _preact.h)(_AlertComponent.default, {
        messageType: "success",
        isVisibleFor: 3000
      }), (0, _preact.h)(_panel.default, {
        title: "Footer type"
      }, (0, _preact.h)("div", {
        className: "community-footer_radio-buttons"
      }, (0, _preact.h)(_RadioInputGroup.default, {
        title: "",
        options: options,
        onChange: function onChange(_, idx) {
          return _this2.setState({
            selectedOption: idx
          });
        },
        value: options[selectedOption]
      })), subComponents[selectedOption] ? (0, _preact.h)("div", {
        className: "community-footer_sub-component"
      }, subComponents[selectedOption]) : null));
    }
  }]);
  return CommunityHeader;
}(_preact.Component);

var _default = CommunityHeader;
exports.default = _default;